/**
 * Date format constants
 */

/** M/D/YY — no leading zeros on month/day (e.g. 5/2/26) */
export const DEFAULT_DATE_PATTERN = "M/d/yy";
